import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import todosSagas from '@iso/redux/todos/saga';
import profileSaga from '@iso/redux/profile/saga';


export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    todosSagas(),
    profileSaga(),
  ]);
}
